const initialState = {
    auth: {
        isFetching: false,
        isLoggedIn: false,
        token: null,
        client: null,
    },
    cart: {
        data: {},
        isFetching: false,
        isLoaded: false,
        error: null,
        promoCode: {
            isFetching: false,
        },
    },
    user: {
        data: {},
        referralIdentifier: null,
        storeCreditEvents: null,
        addressBook: null,
    },
    subscriptions: {
        data: {},
        loading: [],
        error: null,
        success: [],
    },
    orders: {
        data: {},
        loading: [],
        error: null,
        success: [],
    },
};
export default initialState;
